/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ImportJobStatus;
(function (ImportJobStatus) {
    ImportJobStatus["CREATED"] = "CREATED";
    ImportJobStatus["COMMITED"] = "COMMITED";
    ImportJobStatus["REVERTED"] = "REVERTED";
    ImportJobStatus["ARCHIVED"] = "ARCHIVED";
})(ImportJobStatus || (ImportJobStatus = {}));
export function ImportJobStatusFromJSON(json) {
    return ImportJobStatusFromJSONTyped(json, false);
}
export function ImportJobStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ImportJobStatusToJSON(value) {
    return value;
}
